export async function syncfusion_datepicker(id: string, placeholder: string, hasError: boolean) {

    await import('@syncfusion/ej2-base/styles/bootstrap4.css');
    await import('@syncfusion/ej2-buttons/styles/bootstrap4.css');
    await import('@syncfusion/ej2-inputs/styles/bootstrap4.css');
    await import('@syncfusion/ej2-popups/styles/bootstrap4.css');
    await import('@syncfusion/ej2-calendars/styles/bootstrap4.css');

    await import('./loadSyncfusion');

    const { DatePicker } = await import('@syncfusion/ej2-calendars');

    const ele1 = document.getElementById('input_' + id);

    const ele2 = document.getElementById('data_' + id);
    if (ele2.hasAttribute("data-datepicker")) {
        (ele1.parentNode as HTMLElement).classList.toggle('e-error', false);
        return;
    }

    ele2.setAttribute('data-datepicker', 'true');
    const ele2Val = ele2.getAttribute('value');
    let val:Date = null;
    if (ele2Val) {
        val = new Date(ele2Val);
    }
    let datepickerObject = new DatePicker({
        // sets the placeholder
        floatLabelType: "Never",
        placeholder: null,
        showClearButton: false,
        min: new Date(),
        value: val,
        format: 'dd/MM/yyyy',
        change: (args: any) => {
            ele2.setAttribute('value', datepickerObject.value ? datepickerObject.value.toISOString().split('T')[0] : null);
            ele2.dispatchEvent(new Event('change'));
            (ele1.parentNode as HTMLElement).classList.toggle('e-error', false);
        },
        created: (args: any) => {
            (ele1.parentNode as HTMLElement).classList.toggle('e-error', false);
        }
    });
    datepickerObject.appendTo('#input_' + id);
}
